import { Clip } from "../../Model/Clip";

export const ClipEditViewModel = () => {
  const clipFunctions = Clip.getInstance();
  const editTitle = clipFunctions.Title;
  const requestMobile = clipFunctions.RequestMobile;
  return { editTitle, requestMobile };
};
